import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FooterComponent } from '../menu/footer/footer.component';
import { SideNavComponent } from '../menu/side-nav/side-nav.component';

@NgModule({
  declarations: [
    SideNavComponent,
    FooterComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [ SideNavComponent, FooterComponent]
})
export class SharedModule { }
